import { ITippingOption } from "../types";

export const options: ITippingOption[] = [
  {
    name: "ROUNDUP",
    keyName: "ROUNDUP",
    text: "tipping.roundup",
    fixed: true,
    sort_position: 1,
  },
  {
    name: "ABSOLUTE",
    keyName: "ABSOLUTE",
    text: "tipping.customtip",
    fixed: true,
    sort_position: 2,
  },
  {
    name: "PERCENTAGE",
    keyName: "PERCENTAGE_1",
    text: "tipping.custom",
    fixed: false,
    sort_position: 3,
  },
  {
    name: "PERCENTAGE",
    keyName: "PERCENTAGE_2",
    text: "tipping.custom",
    fixed: false,
    sort_position: 4,
  },
  {
    name: "PERCENTAGE",
    keyName: "PERCENTAGE_3",
    text: "tipping.custom",
    fixed: false,
    sort_position: 5,
  },
];